//toda vez que precisamos alterar uma informação passamos pelo reducer
//primeira coisa que criamos é uma interface para tipar os dados que teremos na store
//criar interface dentro do reducer

import { createReducer, on } from '@ngrx/store';
import {
  loadCustomBank,
  loadCustomBankSuccess,
  saveCustomBankSuccess,
} from './custom-bank.actions';

export interface ICustomBankState {
  lista: any[];
  isLoading: boolean;
}

const initialState: ICustomBankState = {
  lista: [],
  isLoading: false,
};

export const customBankReducer = createReducer(
  initialState,
  on(loadCustomBank, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(loadCustomBankSuccess, (state, { lista }) => ({
    ...state,
    lista: [...lista],
    isLoading: false,
  })),

  on(saveCustomBankSuccess, (state, { customBank }) => ({
    ...state,
    lista: [...state.lista, customBank],
  }))
);
//colocar como parametro o customBankReducer lá no app.module
//agora criamos o selector em um novo arquivo
